/**
 * Per–course-type GuardRails rules: course plugin identity, default pathways, allowed unit/lesson/screen
 * plugins, and screen-builder tool/component allow lists (ePub, bronteViewer).
 * @module services/GuardRailsService/GuardRailsCourseConfig
 */
import { PATHWAY_TYPE_FREE } from "services/PathwayService/constants";

/** @type {Record<string, {rules: object}>} */
const GuardrailsRules =
{
  "EPUB": {
    "rules": {
      "coursePluginId": {
        "name": "Pearson eText course plugin",
      },
      "coursePathWays": {
        "pathWays": [
          {
            "key": [
              "cover",
            ],
            "value": PATHWAY_TYPE_FREE,
          },
          {
            "key": [
              "pages",
            ],
            "value": PATHWAY_TYPE_FREE,
          },
          {
            "key": [
              "chapters",
            ],
            "value": PATHWAY_TYPE_FREE,
          },
        ],
      },
      "unit": {
        "plugins": [
          {
            "name": "Simple Unit",
          },
        ],
      },
      "lesson": {
        "plugins": [
          {
            "name": "Standard Lesson",
          },
        ],
      },
      "screen": {
        "plugins": [
          {
            "name": "Screen",
            "description": "A screen of a lesson",
          },
          {
            "name": "eText Screen with Enhanced Text Editor",
            "description": "A screen of a lesson with upgraded slate",
          },
        ],
      },
      "buildComponentGuardRules": {
        "tools": [
          "Text",
          "Image",
          "Table",
          "Spacer",
        ],
        "components":
          [
            "MMI Audio/Video Player",
            "iFrame",
            "eText MCQ",
            "eText Page Break",
            "Spacer",
            "Code Block",
            "SPP Audio Player",
            "SPP Video Player",
          ],
      },
    },
  },
  "BV": {
    "rules": {
      "coursePluginId": {
        "name": "Bronte Viewer eText Plugin",
      },
      "coursePathWays": {
        "pathWays": [
          {
            "key": [
              "cover",
            ],
            "value": PATHWAY_TYPE_FREE,
          },
          {
            "key": [
              "pages",
            ],
            "value": PATHWAY_TYPE_FREE,
          },
          {
            "key": [
              "chapters",
            ],
            "value": PATHWAY_TYPE_FREE,
          },
        ],
      },
      "unit": {
        "plugins": [
          {
            "name": "Simple Unit",
          },
        ],
      },
      "lesson": {
        "plugins": [
          {
            "name": "Standard Lesson",
          },
        ],
      },
      "screen": {
        "plugins": [
          {
            "name": "Screen",
            "description": "A screen of a lesson",
          },
          {
            "name": "eText Screen with Enhanced Text Editor",
            "description": "A screen of a lesson with upgraded slate",
          },
        ],
      },
      "buildComponentGuardRules": {
        "tools": [
          "Text",
          "Image",
          "Table",
          "Spacer",
        ],
        "components":
          [
            "TDX Embedded Assessment Item",
            "MMI Audio/Video Player",
            "iFrame",
            "eText MCQ",
            "eText Page Break",
            "SPP Audio Player",
            "SPP Video Player",
            "Spacer",
            "Code Block",
            "Bronte plugin Single-SPA",
            "Bronte Plugin Journal Learning Tool",
            "Inline socket plugin",
          ],
      },
    },
  },
  "NONE": {
    "rules": {
      "buildComponentGuardRules": {
        "tools": [],
        "components": [],
      },
    },
  },
};

export default GuardrailsRules;